import type { ScaleBand } from 'd3-scale';
import { useTheme } from '@simplywallst/ui-core';
import { Postfix, Label } from './styled';
import { Translation } from '@/hooks/useTranslation';

interface Props {
  yScale: ScaleBand<string>;
  series: string[];
  y: number;
}

const YAxis = ({ yScale, series, y }: Props) => {
  const theme = useTheme();
  return (
    <svg y={y} width="100%" height={yScale.range()[1]}>
      {series.map((n, i) => {
        return (
          <g key={`insider-trading-yaxis-${n}`}>
            <Translation
              i18nKey="page.companyReport.ownership.insiderTradingVolume.chart.yAxisLabel"
              values={{
                series: n,
              }}
            >
              <Label
                y={i * yScale.bandwidth() + theme.x1spacePx}
                dominantBaseline="hanging"
                textAnchor="start"
              >
                {/* Prevents react 18 type errors, as `record` is disallowed as a child type. */}
                {/* This is actually an interpolation for Translation, not an actual object. */}
                {{ series } as never}
              </Label>
              <Postfix
                y={i * yScale.bandwidth() + theme.x4spacePx}
                dominantBaseline="hanging"
                textAnchor="start"
              >
                months
              </Postfix>
            </Translation>
            <rect
              x="0"
              y={i * yScale.bandwidth()}
              width="100%"
              height="1"
              fill={theme.color.white}
              fillOpacity={0.1}
            />
          </g>
        );
      })}
    </svg>
  );
};

export default YAxis;
